import {
  DEAL_ACTION_TOKEN,
  UPDATE_STEP,
  TOGGLE_LOGIN_FORM,
  UPDATE_AUTH_STEP,
  HANDLE_SERVER_ERRORS,
  SHOW_ADDRESS_MODAL,
  HIDE_ADDRESS_MODAL,
  SHOW_WEBCAM_MODAL,
  HIDE_WEBCAM_MODAL,
  SET_IS_UNDERAGE,
  SET_IS_PARENT,
  SET_CONTACT_INFO,
  SET_REQUEST_LIST,
  SET_TITOLARE_LIST,
  SET_CONTRACT_LIST,
  SHOW_LOADING,
  HIDE_LOADING,
  USER_COUNTER,
  ENABLE_BUTTON,
  DISABLE_BUTTON,
  SHOW_API_ALERT_MODAL,
} from '../actions/stepActions'

const initialState = {
  isStepLoading: false,
  isLoading: true,
  isParent: null,
  isUnderage: null,
  contactId: null,
  guid: null,
  widgets_: [],
  pendingActions: [],
  last: false,
  name: '',
  number: null,
  hasServerErrors: false,
  serverErrorMessage: '',
  serverErrorStatus: '',
  userCounter: 0,
  titolareList: [],
  config: {},
  titoWidgets: [],
  titoComponents: [],
  isAPIResError:false
}

/**
 * Step reducer
 * @module  {Reducer} stepReducer
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case HANDLE_SERVER_ERRORS:
      return {
        ...state,
        hasServerErrors: action.hasServerErrors,
        serverErrorMessage: action.serverErrorMessage,
        serverErrorStatus: action.serverErrorStatus,
        isStepLoading: state.isStepLoading && !action.hasServerErrors,
        isLoading: state.isLoading && !action.hasServerErrors,
        pendingActions: !action.hasServerErrors ? state.pendingActions : []
      }

    case TOGGLE_LOGIN_FORM:
      let auth = state.auth

      if (!action.loginFormVisible) {
        auth = !!state.auth.tokenId ? state.auth : null
      }

      return {
        ...state,
        loginFormVisible: action.loginFormVisible,
        auth
      }

    case UPDATE_AUTH_STEP:
      return {
        ...state,
        auth: action.auth
      }

    case DEAL_ACTION_TOKEN:
      let pendingActions = state.pendingActions || []
      if (!!action.token) {
        if (!action.token.dispose) {
          pendingActions = pendingActions.concat(action.token)
        } else {
          const idxToRemove = pendingActions.findIndex(
            a => a.id === action.token.id
          )
          if (idxToRemove > -1) {
            pendingActions.splice(idxToRemove, 1)
          }
        }
      } else {
        pendingActions = state.pendingActions
      }

      const blockingActions = pendingActions.filter(a => !!a.blocking)

      return {
        ...state,
        isStepLoading: blockingActions.length > 0,
        isLoading: blockingActions.length > 0 && action.isLoading,
        pendingActions
      }

    case UPDATE_STEP:
      return {
        ...state,
        number: action.step.number,
        name: action.step.name,
        last: action.step.last,
        widgets_: action.step.widgets_,
        contactId: action.step.contactId,
        guid: action.step.guid,
        titoWidgets: action.step.titoWidgets,
        titoComponents: action.step.titoComponents,
        isLoading:
          action.isLoading !== undefined ? action.isLoading : state.isLoading,
        isParent: action.step.name === 'resume' ? null : state.isParent,
        isUnderage: action.step.name === 'resume' ? null : state.isUnderage,
        auth: action.step.auth || null,
        config: action.step.config || {},
        isStepLoading:false,
        isAPIResError:false
      }

    case SHOW_WEBCAM_MODAL:
      return {
        ...state,
        webcamComponent: action.component
      }

    case HIDE_WEBCAM_MODAL:
      return {
        ...state,
        webcamComponent: null
      }

    case SHOW_ADDRESS_MODAL:
      return {
        ...state,
        addressComponent: action.component
      }

    case HIDE_ADDRESS_MODAL:
      return {
        ...state,
        addressComponent: null
      }

    case SET_IS_UNDERAGE:
      return {
        ...state,
        isUnderage: action.isUnderage
      }

    case SET_IS_PARENT:
      return {
        ...state,
        isParent: action.isParent
      }

    case SET_CONTACT_INFO:
      return {
        ...state,
        ...action.contact
      }

    case SET_REQUEST_LIST:
      return {
        ...state,
        requestList: action.requestList
      }
    case SET_TITOLARE_LIST:
      return {
        ...state,
        titolareList: action.titolareList
      }

    case SET_CONTRACT_LIST:
      return {
        ...state,
        contractList: action.contractList,
        userCounter: state.userCounter
      }
    case SHOW_LOADING:
      return {
        ...state,
        isStepLoading: true
      }
    case HIDE_LOADING:
      return {
        ...state,
        isStepLoading: false
      }
    case USER_COUNTER:
      return {
        ...state,
        userCounter: action.userCounter
      }
    case ENABLE_BUTTON:
      return {
        ...state,
        disableButton: false
      }
    case DISABLE_BUTTON:
      return {
        ...state,
        disableButton: true
      }
      case SHOW_API_ALERT_MODAL:
      return {
        ...state,
        isAPIResError: true,
        isStepLoading:false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./state/reducers/stepReducer.js